import {
	HiOutlineViewGrid,
	HiOutlineCube,
	HiOutlineShoppingCart,
	HiOutlineUsers,
	HiOutlineDocumentText,
	HiOutlineAnnotation,
	HiOutlineQuestionMarkCircle,
	HiOutlineCog
} from 'react-icons/hi'

export const DASHBOARD_SIDEBAR_LINKS = [
	{
		key: 'home',
		label: 'Home',
		path: '/ProfileLayout',
		icon: <HiOutlineViewGrid size={20}/>
	},
	{
		key: 'products',
		label: 'Education Detail',
		path: '/ProfileLayout/PEducation',
		icon: <HiOutlineCube size={20} />
	},
	{
		key: 'orders',
		label: 'Position',
		path: '/ProfileLayout/PPosition',
		icon: <HiOutlineShoppingCart size={20}/>
	},
	{
		key: 'customers',
		label: 'Job Profile',
		path: '/ProfileLayout/PJobProfile',
		icon: <HiOutlineUsers size={20}/>
	},
	{
		key: 'transactions',
		label: 'Accomplishments',
		path: '/ProfileLayout/Paccomplishments',
		icon: <HiOutlineDocumentText size={20} />
	},
	{
		key: 'messages',
		label: 'Volunteering',
		path: '/ProfileLayout/Pvol',
		icon: <HiOutlineAnnotation size={20}/>
	}
]

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS = [
	{
		key: 'settings',
		label: 'Settings',
		path: '/settings',
		icon: <HiOutlineCog />
	},
	{
		key: 'support',
		label: 'Help & Support',
		path: '/support',
		icon: <HiOutlineQuestionMarkCircle />
	}
]